// src/components/shared/JobStatusBadge.tsx
// Reusable status badge for async jobs (HeyGen + ElevenLabs).

import { CheckCircle, Clock, Loader2, XCircle } from 'lucide-react';

const META: Record<string, { label: string; cls: string; icon: JSX.Element }> = {
  pending:    { label: 'Pendiente',   cls: 'bg-amber-500/20 text-amber-700 dark:text-amber-300 border-amber-500/25',     icon: <Clock size={11} /> },
  processing: { label: 'Procesando',  cls: 'bg-sky-500/20 text-sky-700 dark:text-sky-300 border-sky-500/25',           icon: <Loader2 size={11} className="animate-spin" /> },
  completed:  { label: 'Completado',  cls: 'bg-emerald-500/20 text-emerald-700 dark:text-emerald-300 border-emerald-500/25', icon: <CheckCircle size={11} /> },
  failed:     { label: 'Error',       cls: 'bg-red-500/20 text-red-700 dark:text-red-300 border-red-500/25',           icon: <XCircle size={11} /> },
};

export function JobStatusBadge({ status }: { status: string }) {
  const m = META[status] || META.pending;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-medium border ${m.cls}`}>
      {m.icon} {m.label}
    </span>
  );
}
